import { useState } from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { useLang } from '../../../LangContext';
import { downloadBlob } from '../../../services/api';

// Liste ve kanban başlıklarında paylaşılan "Excel'e Aktar" butonu.
// Filtre istemcide uygulandığı için sunucuya yalnızca ekranda görünen kayıtların kimlikleri gönderilir;
// indirilen dosya böylece görünümle birebir aynı kayıtları içerir.
export default function SubmissionExportButton({ items }) {
  const { locale: t, lang } = useLang();
  const [exporting, setExporting] = useState(false);

  async function handleExport() {
    if (exporting || items.length === 0) return;
    setExporting(true);
    try {
      await downloadBlob('/api/submissions/export', 'gonderimler.xlsx', {
        method: 'POST',
        body: { ids: items.map((item) => item.id), lang },
      });
    } catch (exception) {
      window.alert(exception.message);
    } finally {
      setExporting(false);
    }
  }

  return (
    <button
      type="button"
      className="btn btn-light"
      onClick={handleExport}
      disabled={exporting || items.length === 0}
      title={t.submissions.exportExcelHint}
    >
      <FileSpreadsheet /> {exporting ? t.submissions.downloading : t.submissions.exportExcel}
    </button>
  );
}
